import { ReactElement } from 'react';

import { RuleVerificationResult } from '@dreryk/egabinet-prescription-frontend-api';

import { MessageType, StrongText, StyledFlex } from '@dreryk/react-components';

import { PrescriptionStatus } from './PrescriptionStatus';

type RuleVerificationResultsStatusProps = {
   readonly ruleVerificationResults: RuleVerificationResult[] | undefined;
};

export const RuleVerificationResultsStatus = (props: RuleVerificationResultsStatusProps): ReactElement | null => {
   if (!props.ruleVerificationResults?.length) {
      return null;
   }

   return (
      <PrescriptionStatus
         type={MessageType.NEGATIVE}
         label={
            <StyledFlex direction={'column'}>
               {props.ruleVerificationResults.map((result) => (
                  <span key={result.ruleCode}>
                     <StrongText testId={'ruleCode'}>{result.ruleCode}</StrongText>{' '}
                     <span>{result.localizedDescription}</span>
                  </span>
               ))}
            </StyledFlex>
         }
         testId={'ruleVerificationResults'}
      />
   );
};
